import { makeStyles, tokens } from '@fluentui/react-components';

export const useAlertBannersPageStyles = makeStyles({
  pageRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '16px',
  },
  filtersRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '16px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  filterLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: tokens.colorNeutralForeground3,
  },
  resultCount: {
    marginBottom: '8px',
  },
  tableWrapper: {
    overflowX: 'auto',
    overflowY: 'auto',
    width: '100%',
    flex: 1,
    minHeight: '200px',
    scrollbarWidth: 'thin',
  },
  actions: {
    display: 'flex',
    gap: '4px',
  },
  messageCell: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    display: 'block',
    lineHeight: '1.4',
    paddingTop: '4px',
    paddingBottom: '4px',
  },
  iconButton: {
    minWidth: '32px',
    width: '32px',
    height: '32px',
    padding: 0,
  },
  errorBar: {
    marginBottom: '12px',
  },
  addBannerRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '16px',
    marginBottom: '12px',
  },
  divider: {
    border: 'none',
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    margin: 0,
    marginBottom: '16px',
  },
  emptyState: {
    padding: '24px',
    textAlign: 'center',
    color: tokens.colorNeutralForeground3,
  },
});
